import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';

export type KIMessageListenerEvent = {
	type: 'KSEF_BANNER_EVENT';
	action: 'KSEF_CONFIGURATION' | 'CLOSE';
} | {
	type: 'KSEF_WINDOW_EVENT';
	action: 'REFRESH_CONFIGURATION_STATUS' | 'OPEN_KSEF_OFFLINE_PARAMS';
}

@Injectable({
	providedIn: 'root'
})
export class KIMessageListenerService {
	private messageListener$ = new Subject<KIMessageListenerEvent>();

	public constructor() {
		window.addEventListener("message", (event) => this.onMessage(event), false);
	}

	private onMessage(event: MessageEvent) {
		this.messageListener$.next(event.data);
	}

	public get messageListener(): Observable<KIMessageListenerEvent> {
		return this.messageListener$.asObservable();
	}
}
